import BetSlip from "./BetSlip";

const slipKey = (p) => (p ? `${p.matchId}-${p.selection}-${p.side}` : "empty");

// Desktop: sticky side panel. Mobile: slides up from the bottom when a pick exists.
export default function BetSlipDock({ pick, onClear, onPlaced }) {
  return (
    <>
      <div className="hidden lg:block lg:sticky lg:top-20">
        <BetSlip key={slipKey(pick)} pick={pick} onClear={onClear} onPlaced={onPlaced} />
      </div>
      <div
        data-testid="mobile-bet-slip"
        className={`lg:hidden fixed inset-x-0 bottom-0 z-[60] p-2 transition-transform duration-300 ease-out ${pick ? "translate-y-0" : "translate-y-full"}`}
      >
        <div className="max-h-[75vh] overflow-y-auto rounded-t-lg shadow-[0_-10px_40px_rgba(0,0,0,0.7)]">
          {pick && <BetSlip key={slipKey(pick)} pick={pick} onClear={onClear} onPlaced={onPlaced} />}
        </div>
      </div>
    </>
  );
}
